exports.formatSeconds = seconds => {
  if (seconds <= 0) {
    return [0, 0, 0, 0];
  }
  var theTime = parseInt(seconds); // 秒
  var theTime1 = 0; // 分
  var theTime2 = 0; // 小时
  var theTime3 = 0; // 天
  if (theTime >= 60) {
    theTime1 = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    // alert(theTime1+"-"+theTime);
    if (theTime1 >= 60) {
      theTime2 = parseInt(theTime1 / 60);
      theTime1 = parseInt(theTime1 % 60);
      if (theTime2 >= 24) {
        theTime3 = parseInt(theTime2 / 24);
        // theTime2 = parseInt(theTime2 % 24);
      }
    }
  }
  theTime < 10 ? (theTime = '0' + theTime) : (theTime = '' + theTime);
  theTime1 < 10 ? (theTime1 = '0' + theTime1) : (theTime1 = '' + theTime1);
  theTime2 < 10 ? (theTime2 = '0' + theTime2) : (theTime2 = '' + theTime2);
  //时，分，秒
  var result = [theTime2, theTime1, theTime, theTime3];
  return result;
};



// WEBPACK FOOTER //
// ./src/helpers/util.js